import { GET_USER_ROLE_SETTINGS } from '../../types'

const initialState = {
  userRoles: []
}

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_USER_ROLE_SETTINGS: return {
      ...state,
      userRoles: action.payload
    }
    default: return { ...state }
  }
}
